var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevelopmentProcess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2083,
    cy: 40.7054,
    r: 39.4807,
    fill: "white",
    stroke: "url(#paint0_linear_389_7122)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7505 50.0544C58.6683 49.8538 58.5629 49.6695 58.4424 49.4989C58.4345 49.5062 58.4301 49.5099 58.4301 49.5099L43.2545 54.884C42.9031 55.0082 42.5353 55.0714 42.1675 55.0714C41.8489 55.0714 41.5278 55.0222 41.2186 54.9286C40.1246 54.596 39.2812 53.7222 38.9838 52.6163C38.9744 52.5789 38.9698 52.5437 38.9698 52.5061C38.9698 52.266 39.1797 52.0679 39.4317 52.0955C39.443 52.0952 39.4509 52.0955 39.4509 52.0955C40.169 52.2085 41.3614 52.3797 42.2733 52.5322C42.7343 52.6091 43.2217 52.5947 43.6592 52.418C44.054 52.2586 44.4255 51.9866 44.5976 51.5857C44.64 51.4867 44.9048 50.5571 44.7854 50.532L35.4254 48.6385C34.9801 48.5495 34.5187 48.5963 34.1041 48.7791L27.936 51.4871V56.7042L41.6475 60.0893C42.08 60.1958 42.5554 60.1732 42.9798 60.0278C43.0404 60.007 43.1001 59.9839 43.1583 59.9581L57.2915 53.685C58.6805 53.069 59.3269 51.46 58.7505 50.0544Z",
    fill: "url(#paint1_linear_389_7122)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9198 58.118H27.4677C27.7264 58.118 27.9363 57.9083 27.9363 57.6494V51.4863H21.4512V57.6494C21.4512 57.9081 21.6609 58.118 21.9198 58.118Z",
    fill: "url(#paint2_linear_389_7122)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1233 42.4995H51.8198C52.1218 42.4995 52.3665 42.2548 52.3665 41.9529V38.2405C52.3665 37.9385 52.1218 37.6938 51.8198 37.6938C51.5178 37.6938 51.2731 37.9385 51.2731 38.2405V41.4062H31.67V21.8028H37.7209V27.6644C37.7209 27.9663 37.9656 28.211 38.2676 28.211H44.6758C44.9778 28.211 45.2225 27.9663 45.2225 27.6644V21.8028H51.2734V25.4446C51.2734 25.7466 51.5181 25.9913 51.82 25.9913C52.122 25.9913 52.3667 25.7466 52.3667 25.4446V21.2562C52.3667 20.9542 52.122 20.7095 51.82 20.7095H44.6758H38.2676H31.1233C30.8214 20.7095 30.5767 20.9542 30.5767 21.2562V41.9529C30.5767 42.2548 30.8214 42.4995 31.1233 42.4995Z",
    fill: "url(#paint3_linear_389_7122)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.835 34.3604H35.032C34.73 34.3604 34.4854 34.605 34.4854 34.907C34.4854 35.209 34.73 35.4537 35.032 35.4537H37.835C38.137 35.4537 38.3817 35.209 38.3817 34.907C38.3817 34.605 38.137 34.3604 37.835 34.3604Z",
    fill: "url(#paint4_linear_389_7122)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.835 37.6938H35.032C34.73 37.6938 34.4854 37.9385 34.4854 38.2405C34.4854 38.5425 34.73 38.7872 35.032 38.7872H37.835C38.137 38.7872 38.3817 38.5425 38.3817 38.2405C38.3817 37.9385 38.137 37.6938 37.835 37.6938Z",
    fill: "url(#paint5_linear_389_7122)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2565 49.8465C58.6025 48.251 56.8618 47.4146 55.2073 47.9011L45.3085 50.8112C45.3859 50.0612 45.3524 49.8585 45.3411 49.7903C45.1547 48.6645 44.2892 47.752 43.1366 47.466L35.3641 45.5235C34.7656 45.3759 34.1487 45.4199 33.5804 45.6508L28.4827 47.7168V46.3424C28.4827 45.7826 28.0272 45.3271 27.4674 45.3271H21.9206C21.3608 45.3271 20.9053 45.7826 20.9053 46.3424V57.648C20.9053 58.2078 21.3608 58.6633 21.9206 58.6633H27.4679C28.0277 58.6633 28.4832 58.2078 28.4832 57.648V57.402L41.5169 60.6198C41.7393 60.6745 41.9702 60.7016 42.2025 60.7016C42.6079 60.7016 43.0157 60.6189 43.3809 60.4575L57.5139 54.1845C59.1846 53.443 59.9499 51.5377 59.2565 49.8465ZM57.0702 53.1849L42.9378 59.4578C42.5812 59.6154 42.1585 59.6517 41.7789 59.5581L28.0675 56.1731C28.0242 56.1624 27.9802 56.1571 27.9363 56.1571C27.8153 56.1571 27.6964 56.1974 27.5993 56.2735C27.467 56.3771 27.3896 56.5359 27.3896 56.7038V57.5698H21.9986V46.4205H27.3896V48.5239C27.3896 48.5255 27.3891 48.5268 27.3891 48.5281V54.6776C27.3891 54.9636 27.5949 55.2241 27.8794 55.2525C28.2068 55.2853 28.4825 55.0292 28.4825 54.7086V48.8965L33.9915 46.6639C34.3449 46.5204 34.7295 46.4931 35.1008 46.5847L42.8722 48.527C43.602 48.708 44.1473 49.274 44.2617 49.9659C44.282 50.1253 44.2223 50.7434 44.1709 51.1309C44.1502 51.2873 44.0804 51.4342 43.9711 51.5477C43.5698 51.9641 43.0516 52.1077 42.3636 51.9929C41.7802 51.8954 41.085 51.7907 40.4719 51.6982C40.1345 51.6472 39.8213 51.6002 39.5655 51.56C39.2834 51.5156 38.9956 51.6781 38.9228 51.9542C38.8388 52.2726 39.0492 52.5855 39.3658 52.6354C39.6291 52.6767 39.9556 52.7262 40.3087 52.7793C40.918 52.8711 41.6085 52.9752 42.1832 53.0712C42.3936 53.1064 42.5974 53.1239 42.7937 53.1239C43.6903 53.1239 44.434 52.7552 44.98 52.0476L55.5155 48.9503C56.6302 48.6223 57.8036 49.1863 58.2443 50.2615C58.7122 51.401 58.1962 52.6853 57.0702 53.1849Z",
    fill: "url(#paint6_linear_389_7122)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6932 47.5278C23.8347 47.5278 23.1362 48.2263 23.1362 49.0848C23.1362 49.9433 23.8347 50.6419 24.6932 50.6419C25.5517 50.6419 26.2501 49.9435 26.2501 49.0848C26.2501 48.2261 25.5517 47.5278 24.6932 47.5278ZM24.6932 49.5484C24.4376 49.5484 24.2296 49.3404 24.2296 49.0846C24.2296 48.8289 24.4376 48.621 24.6932 48.621C24.9488 48.621 25.1568 48.8289 25.1568 49.0846C25.157 49.3404 24.9488 49.5484 24.6932 49.5484Z",
    fill: "url(#paint7_linear_389_7122)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8204 36.4821C49.1312 36.4821 46.9434 34.2943 46.9434 31.6051C46.9434 28.9158 49.1312 26.728 51.8204 26.728C54.5097 26.728 56.6977 28.9158 56.6977 31.6051C56.6977 34.2943 54.5097 36.4821 51.8204 36.4821ZM50.5503 34.1422C50.6944 34.3053 50.9015 34.3987 51.1189 34.3987H51.1216C51.3403 34.3978 51.5474 34.3029 51.6908 34.1379L55.026 30.2994C55.3007 29.9834 55.267 29.5046 54.9511 29.2299C54.6348 28.9558 54.1563 28.9891 53.8819 29.3051L51.1144 32.4899L49.7996 30.9995C49.5221 30.686 49.0433 30.6557 48.7295 30.9328C48.4156 31.2097 48.3856 31.6888 48.6625 32.0026L50.5503 34.1422Z",
    fill: "url(#paint8_linear_389_7122)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_389_7122",
    x1: 40.2083,
    y1: 0.724609,
    x2: 40.2083,
    y2: 80.6861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_389_7122",
    x1: 43.4485,
    y1: 48.5947,
    x2: 43.4485,
    y2: 60.1556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_389_7122",
    x1: 24.6938,
    y1: 51.4863,
    x2: 24.6938,
    y2: 58.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_389_7122",
    x1: 41.4717,
    y1: 20.7095,
    x2: 41.4717,
    y2: 42.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_389_7122",
    x1: 36.4335,
    y1: 34.3604,
    x2: 36.4335,
    y2: 35.4537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_389_7122",
    x1: 36.4335,
    y1: 37.6938,
    x2: 36.4335,
    y2: 38.7872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_389_7122",
    x1: 40.2085,
    y1: 45.3271,
    x2: 40.2085,
    y2: 60.7016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_389_7122",
    x1: 24.6932,
    y1: 47.5278,
    x2: 24.6932,
    y2: 50.6419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_389_7122",
    x1: 51.8205,
    y1: 26.728,
    x2: 51.8205,
    y2: 36.4821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentProcess);
export default __webpack_public_path__ + "static/media/developmentProcess.5eeb51a4a8ef184ba8f80615e3a7a546.svg";
export { ForwardRef as ReactComponent };